import { EModalAssetsManagerView } from 'src/components/ModalAssetsManager';
import { RootState } from 'src/redux/store';
import { TApplicationState } from 'src/redux/application/application.slice';

export const selectModalAssetManagerActiveView = (
  state: RootState,
): TApplicationState['modalAssetManagerActiveView'] =>
  state.application.modalAssetManagerActiveView;

export const selectModalAssetManagerShowGuide = (
  state: RootState,
): TApplicationState['modalAssetManagerShowGuide'] => state.application.modalAssetManagerShowGuide;

export const selectModalCommunitySummaryView = (
  state: RootState,
): TApplicationState['modalCommunitySummaryView'] => state.application.modalCommunitySummaryView;

export const selectModalHouseSummaryView = (
  state: RootState,
): TApplicationState['modalHouseSummaryView'] => state.application.modalHouseSummaryView;

export const selectModalHouseSummaryFormVariant = (
  state: RootState,
): TApplicationState['modalHouseSummaryFormVariant'] =>
  state.application.modalHouseSummaryFormVariant;

export const selectIsCustomHouseAddingContinuation = (
  state: RootState,
): TApplicationState['isCustomHouseAddingContinuation'] =>
  state.application.isCustomHouseAddingContinuation;

export const selectModalMapHeroDismissed = (
  state: RootState,
): TApplicationState['modalMapHeroDismissed'] => state.application.modalMapHeroDismissed;

export const selectCanaryWaitlistDismissed = (
  state: RootState,
): TApplicationState['canaryWaitlistDismissed'] => state.application.canaryWaitlistDismissed;

export const selectModalMapAlertDismissed = (
  state: RootState,
): TApplicationState['modalMapAlertDismissed'] => state.application.modalMapAlertDismissed;

export const selectUserClickedBuildOnWelcomeScreen = (
  state: RootState,
): TApplicationState['userClickedBuildOnWelcomeScreen'] =>
  state.application.userClickedBuildOnWelcomeScreen;

export const selectSidebarExpanded = (state: RootState): TApplicationState['sidebarExpanded'] =>
  state.application.sidebarExpanded;

export const selectIsCreateOrEditHouseFlow = (state: RootState): boolean =>
  (state.application.modalAssetManagerActiveView !== EModalAssetsManagerView.AddHouse &&
    state.application.modalAssetManagerActiveView !== EModalAssetsManagerView.AddCommunity) ||
  (state.application.modalCommunitySummaryView !== EModalAssetsManagerView.Summary &&
    state.application.modalCommunitySummaryView !== EModalAssetsManagerView.SaveOrSettings) ||
  state.application.modalHouseSummaryView !== EModalAssetsManagerView.Summary;

export const selectIsEmbed = (state: RootState): TApplicationState['isEmbed'] =>
  state.application.isEmbed;

export const selectAppMode = (state: RootState): TApplicationState['appMode'] =>
  state.application.appMode;

export const selectNewCommunity = (state: RootState): TApplicationState['newCommunity'] =>
  state.application.newCommunity;

export const selectOnboardingStep = (state: RootState): TApplicationState['step'] =>
  state.application.step;

export const selectGuideStep = (state: RootState): TApplicationState['guideStep'] =>
  state.application.guideStep;

export const selectTutorialStep = (state: RootState): TApplicationState['tutorialStep'] =>
  state.application.tutorialStep;

export const selectCommunityNotFound = (state: RootState): TApplicationState['communityNotFound'] =>
  state.application.communityNotFound;

export const selectUserCreatedCommunityBefore = (
  state: RootState,
): TApplicationState['userCreatedCommunityBefore'] => state.application.userCreatedCommunityBefore;
